import type { FunctionComponent } from 'react'
import { TypographyV2 as Typography } from '@which/seatbelt'

import { ArticleCTA } from '../../components/ArticleCTA'
import type { ToolFeedbackThankYouModuleProps } from '../../types/toolTypes'
import styles from './ToolFeedbackThankYouModule.module.scss'

export const ToolFeedbackThankYouModule: FunctionComponent<ToolFeedbackThankYouModuleProps> = ({
  articleCTA,
  title,
}) => {
  const { headline, image, link } = articleCTA
  return (
    <div className={styles.toolFeedbackThankYouModule}>
      <Typography
        className={styles.toolFeedbackThankYouModuleTitle}
        tag="h2"
        textStyle="sb-text-heading-medium"
      >
        {title}
      </Typography>
      <ArticleCTA headline={headline} image={image} link={link} title={articleCTA.title} />
    </div>
  )
}
